import React from "react";
import { Text, UploadFile, UploadedFile } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "./DocumentUploadField.module.css";
import {
  STANDARD_UPLOAD_EXTENSIONS,
  getAcceptAttribute,
} from "../../../common/upload/uploadFileRules";
import { useUploadFileGuard } from "../../../common/upload/useUploadFileGuard";
import UploadFileError from "../../../common/upload/UploadFileError";

const DocumentUploadField = ({ label, file, onUpload, onRemove }) => {
  const { t } = useTranslation();
  const { guardOnUpload, fileError } = useUploadFileGuard(STANDARD_UPLOAD_EXTENSIONS);

  return (
    <div className={styles.documentField}>
      {label ? <Text as="label" size="sm" weight="semibold">{label}</Text> : null}
      <div className={styles.uploadWrapper}>
        {!file ? (
          <div className={styles.uploadRow}>
            <UploadFile
              t={t}
              fileList={[]}
              onUpload={guardOnUpload(onUpload)}
              multiple={false}
              className={styles.uploadFile}
              accept={getAcceptAttribute(STANDARD_UPLOAD_EXTENSIONS)}
            />
            <UploadFileError message={fileError} />
          </div>
        ) : (
          <div className={styles.previewRow}>
            <UploadedFile t={t}
              fileName={file.name}
              index={0}
              isEditMode={true}
              removeFile={onRemove}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentUploadField;
